// Toolbar ★ button (favorites the current site) + the optional favorites bar.
import { active } from "./state.js";
import { newTab } from "./tabs.js";
import { navigateTab } from "./navigation.js";
import { openAppPage, favoritePage } from "./linux-open.js";
import * as favorites from "./favorites.js";
import { get, subscribe } from "../shared/settings-store.js";
import { $ } from "./dom.js";

let starBtn = null, barEl = null;
const siteItem = (t) => ({ type: "site", url: t.url, title: t.title });

export function toggleFavorite() {
	const t = active();
	if (!t || !t.url) return;
	favorites.toggle(siteItem(t));
	updateStar();
}

export function updateStar() {
	if (!starBtn) starBtn = $("rv-star");
	if (!starBtn) return;
	const t = active();
	const can = !!(t && t.url);
	const on = can && favorites.has(siteItem(t));
	starBtn.disabled = !can;
	starBtn.classList.toggle("active", on);
	starBtn.setAttribute("aria-pressed", on ? "true" : "false");
	starBtn.title = on ? "Remove from favorites" : "Add to favorites";
}

export function renderFavoritesBar() {
	if (!barEl) barEl = $("rv-bookmarksbar");
	if (!barEl) return;
	const show = !!get("bookmarksBar");
	barEl.hidden = !show;
	if (!show) return;
	barEl.textContent = "";
	const items = favorites.list().filter((f) => f.type === "site" || f.type === "app");
	if (!items.length) {
		const e = document.createElement("span");
		e.className = "rv-bm-empty"; e.textContent = "No favorites yet - tap the ★ on any page.";
		barEl.appendChild(e); return;
	}
	items.forEach((b) => {
		const a = document.createElement("button");
		a.className = "rv-bm-item"; a.textContent = b.title || b.name || b.url; a.title = b.url;
		a.addEventListener("click", () => { if (favoritePage(b)) { openAppPage(favoritePage(b), b.name); return; } const id = newTab(); navigateTab(id, b.url); });
		barEl.appendChild(a);
	});
}

export function initFavoritesUI() {
	starBtn = $("rv-star"); barEl = $("rv-bookmarksbar");
	if (starBtn) starBtn.addEventListener("click", toggleFavorite);
	favorites.subscribe(() => { updateStar(); renderFavoritesBar(); });
	subscribe(() => renderFavoritesBar());
	updateStar();
	renderFavoritesBar();
}
